import React from 'react'

export default function HamburgerArrowRightSvg() {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0391 2.80531C18.0391 2.36055 17.6785 2 17.2338 2L2.3252 2C1.88044 2 1.51989 2.36055 1.51989 2.80531C1.51989 3.25007 1.88044 3.61062 2.3252 3.61062L17.2338 3.61062C17.6785 3.61062 18.0391 3.25007 18.0391 2.80531Z"
        fill="white"
      />
      <path
        d="M18.0391 15.1947C18.0391 14.7499 17.6785 14.3894 17.2338 14.3894L2.3252 14.3894C1.88044 14.3894 1.51989 14.7499 1.51989 15.1947C1.51989 15.6395 1.88044 16 2.3252 16H17.2338C17.6785 16 18.0391 15.6395 18.0391 15.1947Z"
        fill="white"
      />
      <path
        d="M18.0383 6.93263C18.0383 6.48914 17.6788 6.12962 17.2353 6.12962L7.48443 6.12962C7.04094 6.12962 6.68142 6.48914 6.68142 6.93263C6.68142 7.37612 7.04094 7.73565 7.48443 7.73565L17.2353 7.73565C17.6788 7.73565 18.0383 7.37612 18.0383 6.93263Z"
        fill="white"
      />
      <path
        d="M18.0383 11.0624C18.0383 10.6189 17.6788 10.2594 17.2353 10.2594L7.48443 10.2594C7.04094 10.2594 6.68142 10.6189 6.68142 11.0624C6.68142 11.5059 7.04094 11.8654 7.48443 11.8654L17.2353 11.8654C17.6788 11.8654 18.0383 11.5059 18.0383 11.0624Z"
        fill="white"
      />
      <path
        d="M2.07113 6.22826L4.52224 8.76358C4.64842 8.8941 4.64842 9.10572 4.52224 9.23624L2.07113 11.7716C1.86758 11.9821 1.51953 11.833 1.51953 11.5352L1.51953 6.46459C1.51953 6.16684 1.86758 6.01772 2.07113 6.22826Z"
        fill="white"
      />
    </svg>
  )
}
